import { render, staticRenderFns } from "./tenants-popup.vue?vue&type=template&id=5dc89748&scoped=true"
import script from "./tenants-popup.vue?vue&type=script&lang=js"
export * from "./tenants-popup.vue?vue&type=script&lang=js"
import style0 from "./tenants-popup.vue?vue&type=style&index=0&id=5dc89748&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc89748",
  null
  
)

export default component.exports